import React from "react";
import { Identifiable, Project, Task } from "@planzone/dto";
import { SelectList } from "@common/selectList";
import { Input } from "./input";
import { Search } from "./search";
import { Tasks } from "./tasks";
import { Props } from "./types";
import styles from "./styles.scss";

function TasksSelection({ project, resource, selected, onSelect }: Props) {
  const [search, setSearch] = React.useState("");

  return (
    <SelectList rootClassName={styles.root} listClassName={styles.list}>
      {({ isOpen, select }) => ({
        input: <Input selected={selected} isOpen={isOpen} />,
        list: (
          <div className={styles.tasksSelection}>
            <div className={styles.search}>
              <Search search={search} setSearch={setSearch} />
            </div>
            <Tasks
              project={project}
              resource={resource}
              search={search}
              selected={selected}
              onSelect={(task) => select(onSelect(task))}
              isOpen
            />
          </div>
        ),
      })}
    </SelectList>
  );
}

export { TasksSelection };
